import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import {
    AutoScroll,
} from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.logo-carousel-section').forEach((section) => {
        section.querySelectorAll('.lcs-item').forEach((item, index) => {
            const logoSlider = item.querySelector('.lcs-logo-slider');
            if (!logoSlider) {
                return;
            }

            const direction = (index % 2 === 1) ? 'ltr' : 'rtl';
            const splide = new Splide(logoSlider, {
                type: 'loop',
                drag: false,
                arrows: false,
                pagination: false,
                autoWidth: true,
                // clones: 2,
                direction: direction,
                autoScroll: {
                    speed: 0.4,
                    pauseOnHover: false,
                },
            });

            splide.mount({
                AutoScroll,
            });
        });
    });
});